import * as React from "react";

const CustomUser = (props) => (
    <svg
        width={68}
        height={77}
        viewBox="0 0 68 77"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <circle cx={34} cy={34} r={33} fill="white" />
        <circle cx={34} cy={34} r={30} fill="#DBE5EE" />
        <path
            d="M55.5 55L51 60L46.5 62.5C49.5 54.5 39.4 50.4 39 50C38.6 49.6 37.5 46 37.5 43C36.5 43.1667 33.3394 38.5762 35.5 38C43 36 41.5 27 40 22.0001C37.5 26 28.2985 26.6492 25 25C23 24 26 18 29.5 18C29.5 18 33.5 15.5001 35 16.0001C36.5 16.5 38.5 17 38.5 17L42.5 19L44 22.0001L44.5 25.5V35.5L43 39L41 41.5V45L42.5 47.5L47 48L52 49.5L55.5 55Z"
            fill="white"
        />
        <path
            d="M41 41.5001C41.0001 43.5793 40.4496 47.7664 44.109 48.0991C48.6833 48.5149 53.2574 48.0991 54.505 55.1684"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M29.1386 41.4456C29.1386 43.5248 29.4713 47.7663 25.8119 48.099C21.2376 48.5149 16.2475 48.099 15 56"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M25.4395 24.5714L25.9732 24.9375L25.8578 25.5743C25.5468 27.2907 25.4216 28.0611 25.4216 29.802C25.4216 33.6325 26.0396 36.9355 27.5471 39.2544C29.0053 41.4973 31.3736 42.9406 35.2335 42.9406C38.8704 42.9406 41.2528 41.5082 42.7717 39.2426C44.3315 36.916 45.0454 33.6084 45.0454 29.802C45.0454 25.9756 44.4191 22.4919 42.8864 19.9961C41.3991 17.5746 39.0127 16 35.194 16C32.2757 16 28.4989 17.52 26.1611 19.5001C24.9852 20.496 24.3231 21.4825 24.1791 22.3012C24.1114 22.6865 24.1549 23.0446 24.3245 23.3933C24.4989 23.7519 24.8351 24.1568 25.4395 24.5714Z"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M31 36C31 36 31.8889 38 35 38C38.1111 38 39 36 39 36"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M27.4753 47.2673L35 51.4998L42.4456 47.2673"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M44.1089 35.6238C44.1089 35.6238 47.4356 35.6242 47.4356 31.7075C47.4356 27.7908 45.1069 28.1471 45.1069 28.1471"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M25.8119 35.6238C25.8119 35.6238 22.4851 35.6242 22.4851 31.7075C22.4851 27.7908 24.8139 28.1471 24.8139 28.1471"
            stroke="#333F50"
            strokeWidth={2}
        />
        <circle cx={34} cy={34} r={33} stroke="#333F50" strokeWidth={2} />
        <circle
            cx={35}
            cy={64}
            r={12}
            fill="#DBE4EE"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M46 64C46 70.0751 41.0751 75 35 75C35 75 41.2857 70.0751 41.2857 64C41.2857 57.9249 35 53 35 53C41.0751 53 46 57.9249 46 64Z"
            fill="white"
        />
        <path
            d="M33.5895 66.9382V66.7628C33.594 65.9486 33.6705 65.3009 33.8189 64.8196C33.9718 64.3383 34.1877 63.9515 34.4666 63.6591C34.7455 63.3622 35.0851 63.0901 35.4854 62.8427C35.7598 62.6718 36.005 62.4851 36.2209 62.2827C36.4413 62.0758 36.6145 61.8464 36.7404 61.5945C36.8664 61.3381 36.9293 61.0524 36.9293 60.7376C36.9293 60.3822 36.8461 60.0741 36.6797 59.8132C36.5133 59.5523 36.2884 59.3499 36.005 59.206C35.7261 59.062 35.4135 58.9901 35.0671 58.9901C34.7478 58.9901 34.4441 59.0598 34.1562 59.1992C33.8729 59.3342 33.6367 59.5411 33.4478 59.82C33.2634 60.0943 33.1599 60.4429 33.1374 60.8658H30.7354C30.7579 60.0111 30.9648 59.2959 31.3562 58.7202C31.752 58.1444 32.2738 57.7126 32.9215 57.4247C33.5737 57.1368 34.2934 56.9929 35.0806 56.9929C35.9397 56.9929 36.6954 57.1436 37.3477 57.445C38.0044 57.7463 38.5149 58.1759 38.8793 58.7337C39.2481 59.2869 39.4325 59.9437 39.4325 60.7038C39.4325 61.2166 39.3493 61.6754 39.1829 62.0803C39.021 62.4851 38.7893 62.8449 38.4879 63.1598C38.1866 63.4747 37.829 63.7558 37.4151 64.0032C37.0508 64.2281 36.7517 64.462 36.5178 64.7049C36.2884 64.9478 36.1174 65.2334 36.005 65.5618C35.897 65.8857 35.8408 66.286 35.8363 66.7628V66.9382H33.5895ZM34.7635 71.1484C34.3587 71.1484 34.0101 71.0045 33.7177 70.7166C33.4253 70.4287 33.2791 70.0779 33.2791 69.6641C33.2791 69.2592 33.4253 68.9129 33.7177 68.625C34.0101 68.3371 34.3587 68.1932 34.7635 68.1932C35.1638 68.1932 35.5102 68.3371 35.8026 68.625C36.0994 68.9129 36.2479 69.2592 36.2479 69.6641C36.2479 69.9384 36.1781 70.1881 36.0387 70.413C35.9038 70.6379 35.7238 70.8178 35.4989 70.9528C35.2785 71.0832 35.0334 71.1484 34.7635 71.1484Z"
            fill="#333F50"
        />
    </svg>
);

export default CustomUser;
